import { isFiniteNumber } from '@core';

import { CorridorParameterMargins } from '@data';
import { Box } from '../../../Layout';
import { CorridorFrame } from './Components/CorridorFrame';
import { RangeLabel } from './Components/RangeLabel/RangeLabel';
import { ValueMarker } from './Components/ValueMarker/ValueMarker';
import type { ParameterCardCorridorProps } from './ParameterCardCorridors';
import * as css from './ParameterCardCorridors.css';

export type Corridor = Pick<CorridorParameterMargins, 'innerMin' | 'innerMax'>;

const CORRIDOR_WIDTH_RATIO = 0.6;
const OUTSIDE_LAYOUT_RATIO = (1 - CORRIDOR_WIDTH_RATIO) / 2;
const OUTSIDE_RANGE_RATIO = OUTSIDE_LAYOUT_RATIO / CORRIDOR_WIDTH_RATIO;
const CORRIDOR_LEFT_PERCENT = OUTSIDE_LAYOUT_RATIO * 100;
const CORRIDOR_WIDTH_PERCENT = CORRIDOR_WIDTH_RATIO * 100;

const getSingleCorridorExtent = (corridor: Corridor) => {
    const range = corridor.innerMax - corridor.innerMin;
    const outsideRange = range * OUTSIDE_RANGE_RATIO;

    return {
        min: corridor.innerMin - outsideRange,
        max: corridor.innerMax + outsideRange,
    };
};
export const ParameterCardSingleCorridor = ({
    corridorParameterMargins,
    goalCorridor,
    unit,
    value,
    indicatorColor,
}: ParameterCardCorridorProps) => {
    const corridor = goalCorridor ?? corridorParameterMargins;

    if (!corridor) return null;

    const extent = getSingleCorridorExtent(corridor);
    const tone = goalCorridor ? 'goal' : 'system';

    return (
        <Box position="relative" className={css.root}>
            <Box height="100%" position="relative">
                <CorridorFrame
                    tone={tone}
                    left={CORRIDOR_LEFT_PERCENT}
                    right={CORRIDOR_LEFT_PERCENT + CORRIDOR_WIDTH_PERCENT}
                />

                <RangeLabel
                    value={corridor.innerMin}
                    unit={unit}
                    tone={tone}
                    placement={goalCorridor ? 'goal-inside-start' : 'system-start'}
                    position={CORRIDOR_LEFT_PERCENT}
                />
                <RangeLabel
                    value={corridor.innerMax}
                    unit={unit}
                    tone={tone}
                    placement={goalCorridor ? 'goal-inside-end' : 'system-end'}
                    position={CORRIDOR_LEFT_PERCENT + CORRIDOR_WIDTH_PERCENT}
                />
                {isFiniteNumber(value) ? (
                    <ValueMarker value={value} extent={extent} indicatorColor={indicatorColor} />
                ) : null}
            </Box>
        </Box>
    );
};
